import { makeStyles } from "@material-ui/core";
import React, { useCallback } from "react";
import { blue } from '@mui/material/colors';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: 2,
    background: "#fff",
    borderBottom: "1px solid #eee",
    display: "flex",
    flexDirection: 'column',
    alignItems: "baseline",
    justifyContent: 'space-around',
    gap: 0,
  },
  containerStyle: {
    padding: 4,
    color: 'white',
    background: blue[700],
    borderBottom: "1px solid #ffffff",
    display: "flex",
    alignItems: "baseline",
    justifyContent: 'space-between',
    gap: 0,
  },
  labelStyle: {
    marginLeft: 10,
    fontSize: 14
  },
  selectStyle: {
    fontSize: 14,
    padding: "4px 8px",
    marginRight: 25,
    borderRadius: 4,
    border: 'none'
  },
  wrapperSelect: {
    padding: 2,
    display: "flex",
    alignItems: "baseline",
    gap: 2,
  },
  box: {
    width: 20,
    height: 20,
    border: '2px solid #ccc',
    borderRadius: 6,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s ease',

    '$labelcheckbox:hover &': {
      borderColor: '#4CAF50',
    },
  },
  checked: {
    backgroundColor: '#4CAF50',
    borderColor: '#4CAF50',

    '$labelcheckbox:hover &': {
      backgroundColor: '#4CAF50',
      borderColor: '#4CAF50',
    },
  },
  checkIcon: {
    color: '#fff',
    transform: 'scale(0)',
    transition: 'transform 0.2s ease',
  },
  checkIconVisible: {
    transform: 'scale(1)',
  },
  input: {
    position: 'absolute',
    opacity: 0,
    width: 0,
    height: 0,
  },
  option: {
    textDecoration: "bold"
  },
  tableLableStyle: {
    marginLeft: 80
  }
}))

const toSelectValue = (id) => {
  if (id === null || id === undefined || id === "") return "";
  return String(id);
};

const PriceTableSelector = ({ nomeFilial, tabelas, selectedId, onChange, disabled }) => {
  const classes = useStyles();
  const lista = Array.isArray(tabelas) ? tabelas.filter((t) => t && t.id != null) : [];
  const isDisabled = Boolean(disabled);

  const handleChange = useCallback((e) => {
    if (typeof onChange !== "function") return;
    const raw = e && e.target ? e.target.value : "";
    if (raw === "") {
      onChange(null);
      return;
    }
    const parsed = Number(raw);
    onChange(Number.isFinite(parsed) ? parsed : null);
  }, [onChange]);

  return (
    <div className={classes.containerStyle}>
      <div>
        <p className={classes.labelStyle}>
          Estoque da loja: <b>{nomeFilial && nomeFilial.length > 0 ? nomeFilial : 'Selecione uma filial'}</b>
        </p>
      </div>
      {lista.length >= 1 && (
        <>
          <label className={classes.tableLableStyle}>Tabela: </label>
          <div className={classes.wrapperSelect}>
            <select
              disabled={isDisabled}
              value={toSelectValue(selectedId)}
              className={classes.selectStyle}
              onChange={handleChange}
            >
              <option className={classes.option} value="">
                Selecione uma tabela
              </option>
              {lista.map((t) => (
                <option className={classes.option} key={t.id} value={toSelectValue(t.id)}>
                  {t.nome}
                </option>
              ))}
            </select>
          </div>
        </>
      )}
    </div>
  );
};

export default React.memo(PriceTableSelector);
